module.exports = __webpack_public_path__ + "static/media/btn_planned_events_1075_725.1ed67165.png";